import React from 'react'
import JobDescription from '../../../../Components/JobDescription'

const CustomerSupport = () => {
  return (
   <JobDescription 
  jobTitle="Customer Support Specialist"
  location="Chennai"
  department="Customer Support"
  jobType="Full-Time"
  experienceLevel="1-2 Years"
  roleDescription="Be the voice of {brandName} and make a real difference in our customers' experience! We're looking for a Customer Support Specialist who is passionate about helping people, solving problems, and building lasting relationships."
  responsibilities={[
    "Provide exceptional customer support via chat, email, and phone",
    "Resolve customer inquiries and technical issues promptly",
    "Maintain detailed records of customer interactions",
    "Collaborate with technical teams to escalate complex issues",
    "Identify customer pain points and suggest improvements",
    "Create and update help documentation and FAQs",
    "Follow up with customers to ensure satisfaction",
  ]}
  skills={[
    "Excellent written and verbal communication",
    "Active listening and empathy",
    "Problem-solving and critical thinking",
    "Multitasking and time management",
    "Basic technical troubleshooting",
  ]}
  requirements={[
    "1-2 years of customer service experience (or fresh graduates welcome)",
    "Strong interpersonal and communication skills",
    "Patience and positive attitude under pressure",
    "Willingness to learn new tools and processes",
    "Flexible to work in shifts if needed",
  ]}
  benefits={[
    "Comprehensive training program and career development path.",
    "Friendly, supportive team environment with regular feedback.",
    "Opportunity to directly impact customer satisfaction and company growth.",
  ]}
  onApply={() => console.log("Applied for Customer Support Specialist")}
  applyUrl="/apply/customer-support-specialist"
/>
  )
}

export default CustomerSupport